import { CONSTANTS } from 'config';
import template from './plans.html';
import './plans.styl';

function plansComponent($tszToast, PlanService, PropertyService) {

  'ngInject';

  this.loadPlans = () => {
    PlanService.list()
    .then((result) => {
      this.plans = result;
    }).catch(() => {
      $tszToast.showError('Error al cargar la lista de planes');
    });
  };

  this.save = (plan) => {
    PlanService.save(plan)
    .then(() => {
      $tszToast.showSuccess('Plan actualizado correctamente');
    }).catch(() => {
      $tszToast.showError('Error al intentar actualizar el plan');
    });
  };

  this.loadPromotionalMessage = () => {
    PropertyService.get(CONSTANTS.PROPERTY.PROMOTIONAL_MSG)
    .then((result) => {
      this.promotionalMessage = result.value;
    }).catch(() => {
      $tszToast.showError('Error al cargar la lista de planes');
    });
  };

  this.savePromotionalMessage = (promotionalMessage) => {
    console.log(promotionalMessage);
    PropertyService.save({
      name: CONSTANTS.PROPERTY.PROMOTIONAL_MSG,
      value: promotionalMessage,
    })
    .then(() => {
      $tszToast.showSuccess('Propiedad actualizada correctamente');
    }).catch(() => {
      $tszToast.showError('Error al intentar guardar la propiedad');
    });
  };

  //
  // INIT
  //

  this.loadPlans();
  this.loadPromotionalMessage();

}

export default {
  template,
  controller: plansComponent,
};



// WEBPACK FOOTER //
// ./src/containers/plans/index.js